<template>
<router-view></router-view>
</template>

<script>
export default {
  name: 'User'
};
</script>

<style lang="less" scoped>
</style>
